import React from 'react';
import { ChakraV3 } from '..';

export interface RadioStackOption {
  value: string;
  label: string;
  description?: string | React.ReactElement;
  icon?: React.ReactElement;
  extraContent?: React.ReactElement;
  isDisabled?: boolean;
}

export interface RadioStackProps extends Omit<ChakraV3.RadioCard.RootProps, 'onChange'> {
  options: RadioStackOption[];
  value: string;
  onChange: (value: string) => void;
}

export const RadioStack = (props: RadioStackProps) => {
  const { options, value, onChange, ...rest } = props;

  return (
    <ChakraV3.RadioCard.Root
      value={value}
      onValueChange={(details) => details.value && onChange(details.value)}
      colorPalette='brand'
      {...rest}
    >
      <ChakraV3.Stack>
        {options.map((option) => (
          <ChakraV3.RadioCard.Item key={option.value} value={option.value} width='full' data-value={option.value} disabled={option.isDisabled}>
            <ChakraV3.RadioCard.ItemHiddenInput />
            <ChakraV3.RadioCard.ItemControl
              alignItems='center'
              gap={4}
              data-pw={`${option.label}-radio`}
            >
              <ChakraV3.RadioCard.ItemIndicator />
              {option.icon && <ChakraV3.Icon size='md'>{option.icon}</ChakraV3.Icon>}
              <ChakraV3.RadioCard.ItemContent>
                <ChakraV3.RadioCard.ItemText w='full'>{option.label}</ChakraV3.RadioCard.ItemText>
                {option.description && (
                  <ChakraV3.RadioCard.ItemDescription w='full'>
                    {option.description}
                  </ChakraV3.RadioCard.ItemDescription>
                )}
              </ChakraV3.RadioCard.ItemContent>
            </ChakraV3.RadioCard.ItemControl>
          </ChakraV3.RadioCard.Item>
        ))}
      </ChakraV3.Stack>
    </ChakraV3.RadioCard.Root>
  );
};
